export default "__VITE_ASSET__JX9qL_dt__"